import { render, staticRenderFns } from "./ModalContact.vue?vue&type=template&id=076e6f2b&scoped=true&"
import script from "./ModalContact.vue?vue&type=script&lang=js&"
export * from "./ModalContact.vue?vue&type=script&lang=js&"
import style0 from "./ModalContact.vue?vue&type=style&index=0&id=076e6f2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076e6f2b",
  null
  
)

export default component.exports